<template>
  <Dialog :commonDialog="dialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Position </v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="createContractType"
          >
            <span class="font-size-16 font-weight-600">Add Position</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col md="12" class="py-0">
              <table class="width-100">
                <tbody>
                  <tr v-for="(type, index) in user_designation" :key="index">
                    <td>
                      <v-text-field
                        v-model.trim="type.text"
                        dense
                        filled
                        label="Position"
                        solo
                        flat
                        class="px-4 py-2"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        color="cyan"
                        :maxlength="100"
                        :error="designationRule(type.text) !== true"
                      ></v-text-field>
                      <p
                        v-if="designationRule(type.text) !== true"
                        class="mb-0 mt-1 px-4 font-size-12 red--text text--darken-1"
                      >
                        {{ designationRule(type.text) }}
                      </p>
                    </td>
                    <td width="50">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on:click="deleteContractType(index)"
                            color="deep-orange"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <span>Click here to delete</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-container>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="saveDisabled"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateContractSetting"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
export default {
  mixins: [ValidationMixin],
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    e_designation: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    e_designation: {
      deep: true,
      immediate: true,
      handler(param) {
        this.user_designation = this.lodash.cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      user_designation: [
        {
          title: null,
        },
      ],
    };
  },
  methods: {
    designationRule(value) {
      if (!String(value || "").trim()) {
        return "Position is required";
      }
      return this.validateRules.validAlphaNumeric(value, "Position");
    },
    isBlankDesignation(type) {
      return !type || !String(type.text || "").trim();
    },
    isValidDesignation(type) {
      return this.designationRule(type && type.text) === true;
    },
    updateContractSetting() {
      const _this = this;

      if (
        _this.user_designation.some(
          (type) =>
            _this.isBlankDesignation(type) || !_this.isValidDesignation(type)
        )
      ) {
        return;
      }

      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/customer-designation",
          data: { customer_designation: _this.user_designation },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-e-designation", true);
        })
        .catch((error) => {
          _this.logError(error);
          _this.$emit("get-e-designation", true);
        })
        .finally(() => {
          // _this.$emit("close-dialog", true);
          _this.pageLoading = false;
        });
    },
    createContractType() {
      this.user_designation.push({
        text: null,
      });
    },
    deleteContractType(index) {
      if (this.user_designation.length > 1) {
        this.user_designation.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    saveDisabled() {
      return (
        this.pageLoading ||
        !this.user_designation.length ||
        this.user_designation.some((type) => !this.isValidDesignation(type))
      );
    },
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
